// Trang tra cứu tờ trình V2 (/ho-so-truc-tuyen/:hash) — đọc bảng tk_*.
// UI giữ nguyên như V1 XemToTrinh; đổi endpoint + file_watermark -> file_signed.
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import { confirmAlert } from "react-confirm-alert";
import Moment from "react-moment";
import FilePreviewList from "../workflows/FilePreviewList";
import iconsend from "../assets/img/icon-send.png";
import Loading from "../component/Loading";
import { checkRole } from "../model";
import parse from "html-react-parser";
import Spinner from "../component/Spinner";
import ViewUserInfo from "../component/ViewUserInfo";
import { trinhKyApi } from "./services/trinhKyApi";
import { groupStepsByPosition } from "./constants/trinhKy";

export default function XemToTrinhV2() {
  const { user } = useSelector((state) => state.auth);
  const { id } = useParams(); // hash_code
  const { saveWorkfollow } = useSelector((state) => state.save);
  const [detail, setDetail] = useState(null);
  const [myMessage, setMyMessage] = useState("");
  const [listMessage, setListMessage] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const roleCancle = checkRole(user, "workflow_walking", "cancle");
  const [reloading, setReloading] = useState(false);
  const timeoutRef = useRef(null);
  const [showInfo, setShowInfo] = useState(false);

  const defaultDetail = { title: "", workflow_type: 0, code: "", code_file: "", status: 1, position: 1, list_file: [] };

  const fetchDetail = () => {
    setPageLoading(true);
    trinhKyApi
      .getByHash(user.config, id)
      .then((res) => {
        setPageLoading(false);
        if (res.data.status === "success") {
          const dataif = res.data.data || {};
          dataif.list_file = dataif.list_file && JSON.parse(dataif.list_file);
          dataif.file_signed = dataif.file_signed && JSON.parse(dataif.file_signed);
          dataif.file_attachments = dataif.file_attachments && JSON.parse(dataif.file_attachments);
          dataif.groupedList = groupStepsByPosition(dataif?.workflow_steps_json || []);
          setListMessage(dataif.messages);
          setDetail(dataif);
        }
      })
      .catch((e) => {
        console.log(e);
        setPageLoading(false);
      });
  };

  useEffect(() => {
    fetchDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchMessage = useCallback(() => {
    if (detail) {
      trinhKyApi
        .listMessages(user.config, detail.id)
        .then((res) => {
          if (res.data.status === "success") setListMessage(res.data.data);
        })
        .catch((e) => console.log(e));
    }
  });

  useEffect(() => {
    if (detail && saveWorkfollow) {
      if (saveWorkfollow.workfollow_id == detail.id) {
        if (saveWorkfollow.node_type === "message") fetchMessage();
        if (saveWorkfollow.node_type === "workfollow") {
          fetchDetail();
          fetchMessage();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveWorkfollow, detail]);

  const formik = useFormik({
    initialValues: detail ? detail : defaultDetail,
    enableReinitialize: true,
    onSubmit: () => {},
  });

  const sendMessage = () => {
    if (myMessage && myMessage !== "") {
      trinhKyApi
        .sendMessage(user.config, { request_id: detail.id, user_id: user.data.id, message: myMessage })
        .then((res) => {
          if (res.data.status === "success") setMyMessage("");
          else confirmAlert({ title: "Lỗi", message: res.data.message, buttons: [{ label: "OK" }] });
        })
        .catch((err) => console.log(err));
    }
  };

  const huybototrinh = () => {
    confirmAlert({
      title: "Cảnh báo",
      message: "Bạn muốn Hủy Bỏ tờ trình này ?",
      buttons: [
        {
          label: "Có",
          onClick: () => {
            trinhKyApi
              .cancel(user.config, detail.id)
              .then((res) => {
                if (res.data.status === "success") {
                  confirmAlert({ title: "Thông báo", message: "Hủy bỏ thành công", buttons: [{ label: "OK", onClick: () => window.location.reload() }] });
                } else {
                  confirmAlert({ title: "Lỗi", message: res.data.message, buttons: [{ label: "OK" }] });
                }
              })
              .catch((err) => console.log(err));
          },
        },
        { label: "Không" },
      ],
    });
  };

  const taofilettr = () => {
    confirmAlert({
      title: "Cảnh báo",
      message: "Bạn muốn Tạo lại file tờ trình này ?",
      buttons: [
        {
          label: "Có",
          onClick: () => {
            setReloading(true);
            trinhKyApi
              .regenerateFile(user.config, id)
              .then((res) => {
                setReloading(false);
                if (res.data.status === "success") {
                  confirmAlert({ title: "Thông báo", message: "Tạo lại thành công", buttons: [{ label: "OK", onClick: () => window.location.reload() }] });
                } else {
                  confirmAlert({ title: "Lỗi", message: res.data.message, buttons: [{ label: "OK" }] });
                }
              })
              .catch((err) => {
                console.log(err);
                setReloading(false);
              });
          },
        },
        { label: "Không" },
      ],
    });
  };

  const mavTitle = () => {
    if (id) {
      if (detail) {
        if (detail.status == 2) return "Xem tờ trình";
        if (detail.author_id != user.data.id) return "Phê duyệt tờ trình";
        return "Cập nhật tờ trình";
      }
      return "Cảnh báo";
    }
    return "";
  };
  const handleMouseEnter = () => { timeoutRef.current = setTimeout(() => setShowInfo(true), 300); };
  const handleMouseLeave = () => { clearTimeout(timeoutRef.current); setShowInfo(false); };

  return (
    <AkkhorLayout idrole="workflow_walking">
      <div className="breadcrumbs-area">
        <ul>
          <li><Link to="/">Trang chủ</Link></li>
          <li><Link to="/workflow_walking">Danh sách tờ trình</Link></li>
          <li>{mavTitle()}</li>
        </ul>
      </div>

      <div className="card height-auto">
        <div className="card-body pb-5">
          <div className="heading-layout1">
            <div className="item-title"><h3>{mavTitle()}</h3></div>
            <div className="">
              {detail && (
                <>
                  {detail.status == 1 && <span className="p-2 border border-info rounded text-info">Chưa hoàn tất</span>}
                  {detail.status == 2 && <span className="p-2 border border-success rounded text-success">Đã được duyệt</span>}
                  {detail.status == 4 && <span className="p-2 border border-danger rounded text-danger">Tờ trình đã bị hủy</span>}
                </>
              )}
            </div>
          </div>
          {pageLoading && <Loading />}
          <form className="new-added-form form-totrinh">
            {detail ? (
              <>
                <div className="row">
                  <div className="col-12 col-sm-3 form-group">
                    <label>Tên tờ trình</label>
                    <div className="form-control">{detail.title}</div>
                  </div>
                  <div className="col-12 col-sm-3 form-group">
                    <label>Số tờ trình</label>
                    <div className="form-control">{detail.code}</div>
                  </div>
                  <div className="col-12 col-sm-3 form-group">
                    <label>Loại tờ trình: </label>
                    <div className="form-control">{detail.type_name}</div>
                  </div>
                  <div className="col-12 col-sm-3 form-group" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <label>Người tạo</label>
                    <strong>{detail.author_name}|{detail.author_department}</strong><br />
                    {showInfo && <ViewUserInfo type="right" user_id={detail.author_id} />}
                    <small>Ngày tạo: <Moment format="DD/MM/YYYY">{new Date(detail.datecreate * 1000)}</Moment></small>
                  </div>

                  <div className="col-12 col-sm-9 form-group">
                    {detail && detail.status !== 4 ? (
                      <div className="w-100">
                        <label>File scan <span className="text-danger">*</span></label>
                        <FilePreviewList formik={formik} rowname={"file_signed"} detail={detail} id={id} />
                      </div>
                    ) : (
                      <div className="w-100">
                        <label>File scan <span className="text-danger">*</span></label>
                        <FilePreviewList formik={formik} rowname={"list_file"} detail={detail} id={id} />
                      </div>
                    )}
                    <hr />
                    <div className="w-100">
                      <label>Tài liệu tham khảo <small style={{ fontSize: 10 }}>(Không bắt buộc và sẽ không cho vào trong file tờ trình chính)</small></label>
                      <FilePreviewList formik={formik} rowname={"file_attachments"} detail={detail} id={id} />
                    </div>
                  </div>

                  <div className="col-12 col-sm-3 form-group message-group">
                    <div className="w-100 wrapper border rounded">
                      <div className="w-100 ms-header p-2 border-bottom">
                        <h5 className="w-100 text-center">Hoạt động</h5>
                      </div>
                      <div className="list-message">
                        {listMessage && listMessage.map((ms) => (
                          <div className="w-100 message-item border-bottom" key={ms.id}>
                            <strong>{ms.fullname}:</strong><span>{parse(ms.message || "")}</span><br />
                            <small><span className="far fa-clock"></span> <Moment format="HH:mm DD/MM/YYYY">{new Date(ms.datecreate * 1000)}</Moment></small>
                          </div>
                        ))}
                      </div>
                      <div className="message-action border-top">
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="Nhập nội dung..." value={myMessage} onChange={(e) => setMyMessage(e.target.value)} />
                          <div className="input-group-prepend">
                            <button type="button" className="btn btn-sm btn-succss" onClick={() => sendMessage()}>
                              <img src={iconsend} alt="send" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="row">
                      <h3 className="w-100 text-center mb-3">Quy trình phê duyệt</h3>
                      {detail.groupedList && detail.groupedList.map((group) => (
                        <div className="col-12 col-sm-4 mb-2 item-totrinh" key={group.position}>
                          <div className="wrapper border rounded shaddow">
                            <h4 className="text-center item-header pl-3 pr-3 pt-2 pb-2 border-bottom">
                              {group.position}. {group.group_name}
                            </h4>
                            <div className="w-100 pl-3 pr-3 pt-2 pb-2 info">
                              {group.member.map((m) => (
                                <div className="item-user" key={m.id}>
                                  <div className="user-status">
                                    <div className=""><strong>{m.fullname}</strong></div>
                                    <div className="check_status">
                                      {m.action == 1 && (<p className="text-success"><span className="fas fa-check-circle"></span><i className="ml-1"> Đã duyệt</i></p>)}
                                      {m.action == 2 && (<p className="text-info"><span className="fas fa-times-circle"></span><i className="ml-1"> Yêu cầu bổ sung</i></p>)}
                                      {m.action == 3 && (<p className="text-danger"><span className="fas fa-times-circle"></span><i className="ml-1"> Trả về</i></p>)}
                                      {m.action == 4 && (<p className="text-danger"><span className="fas fa-times-circle"></span><i className="ml-1"> Hủy bỏ</i></p>)}
                                      {m.action == 0 && (<p className="text-warning"><span className="fas fa-clock"></span><i className="ml-1"> Chờ ký</i></p>)}
                                      {m.timecheck && <small><span className="far fa-clock"></span><Moment format="HH:mm DD/MM/YYYY">{m.timecheck}</Moment></small>}
                                    </div>
                                  </div>
                                  <div className="check-comment">
                                    {m.note_comment && (
                                      <div className="w-100"><i className="far fa-comment-dots"></i><small> {m.note_comment}</small></div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {detail.status == 2 && (
                  <div className="item-totrinh verified">
                    <div className="wrapper">
                      <img src="https://apihr.bhsgroup.vn/images/logo-bhs-signed.png" alt="signed" />
                    </div>
                  </div>
                )}
                {detail.status == 4 && (
                  <div className="item-totrinh verified">
                    <div className="wrapper">
                      <h3 className="text-danger p-3 border border-danger rounded">Tờ trình đã bị hủy</h3>
                    </div>
                  </div>
                )}
                {detail && detail.status != 4 && roleCancle && (
                  <>
                    <div className="col-12 text-center form-group mt-5">
                      <button type="button" onClick={() => huybototrinh()} className="btn btn-danger">Hủy bỏ tờ trình</button>
                    </div>
                    <div className="col-12 text-center form-group mt-5">
                      <button type="button" onClick={() => taofilettr()} className="btn btn-warning">
                        {reloading ? (<><Spinner /> Loading ...</>) : (<><span className="fas fa-undo-alt"></span> Tạo lại file tờ trình</>)}
                      </button>
                    </div>
                  </>
                )}
              </>
            ) : (
              <h3 className="text-danger">Không tìm thấy tờ trình hoặc bạn không có quyền xem tờ trình này</h3>
            )}
          </form>
          <div className="w-100 mb-5"></div>
        </div>
      </div>
    </AkkhorLayout>
  );
}
